export default function unhandledCase(caze: any): Error {
  return new Error(`Unhandled case "${JSON.stringify(caze)}"`);
}
